module.exports = __webpack_public_path__ + "static/turquia-011-8b62cf273257f4d9387cd16137bb1579.jpg";